import { memo } from 'react';
import Slider, { SliderProps } from 'rc-slider';
export const InputSlider = memo(({ trackStyle, handleStyle, ...rest }: SliderProps) => (
  <Slider
    trackStyle={trackStyle || defaultTrackStyle}
    handleStyle={handleStyle || [defaultDotStyle, defaultDotStyle]}
    data-cy="input-slider"
    {...rest}
  />
));
export default InputSlider;
const defaultDotStyle = {
  backgroundColor: 'white',
  height: 16,
  width: 16,
  bordercolor: '#693eb5',
  opacity: 1,
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
};
const defaultTrackStyle = [{ backgroundColor: '#693eb5' }];
